import ProcessModal from "./process-modal";

export default ProcessModal;
